import React, { useContext } from 'react';
import LanguageSelector from "./LanguageSelector";
import ImageSlider from '../components/ImageSlider';
import Description from './Description';
import Notice from './Notice';
import ArticleList from './ArticleList';
import ArticleSubmission from './ArticleSubmission';
import Footer from './Footer';
import { LanguageContext } from '../contexts/LanguageProvider';
import { LANGUAGES } from '../constant/languages';
import { Helmet } from 'react-helmet';

const Home: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const title = language === LANGUAGES.JA ? '民族文化生物学研究会' : 'Society for Ethno-Cultural Biology';
  // 日本時間3/16 0:00 以降に非表示
  const currentTime = new Date().getTime();
  const hideTime = new Date("2025-05-25T00:00:00+09:00").getTime();
  const showNotice = currentTime < hideTime;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className="container mx-auto p-6">
        <h1 className="relative text-3xl sm:text-5xl font-extrabold text-center">
          {title}
        </h1>
        <LanguageSelector />
        <div className="mx-auto max-w-4xl">
          <ImageSlider />
          <Description />
          {showNotice && <Notice />}
          <ArticleList />
          <ArticleSubmission />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
